import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import * as S from './styled';
import srcProcessErr from '../assets/process-err.svg';
import srcProcessErrMobile from '../assets/process-err-mobile.svg';
import srcProcessErrTablet from '../assets/process-err-tablet.svg';
import srcProcessLoading from '../assets/process-loading.svg';
import srcProcessLoadingMobile from '../assets/process-loading-mobile.svg';
import srcProcessLoadingTablet from '../assets/process-loading-tablet.svg';
import srcProcessDownload from '../assets/process-download.svg';
import srcProcessDownloadMobile from '../assets/process-download-mobile.svg';
import srcProcessDownloadTablet from '../assets/process-download-tablet.svg';
import ReusableButton from '../../../../../../reusables/Button';
import ReusableCard from '../../../../../../reusables/Card';
import ReusableTitle from '../../../../../../reusables/Title';
import { downloadCertificate } from '../../../certificates-constancies/type1/progress/CertificateType01ProgressViewController';
import { Creators as downloadDocumentActions } from '@/domain/useCases/procedures/certificateType01/downloadDocumentUseCase';
import imgWarning from '../../../../../../../assets/illustrations/warning.svg';
import routes from '@/presentation/components/Routes/routingMap';
import MyModal from '@/presentation/modules/procedures/components/Modals/MyModal';

interface IProps {
  active: boolean;
  option: number;
  document: any;
  dateOfPayment: any;
  deprecated?: boolean;
  status?: string;
  fileName?: string;
  title?: string;
}

const StepConstancy = ({
  active,
  option,
  document,
  dateOfPayment,
  deprecated,
  status,
  fileName = 'Certificado-de-estudios',
  title = 'Tu certificado esta listo'
}: IProps) => {
  const dispatch = useDispatch();
  const options = [
    {
      description:
        'El estado del trámite se actualizará en unos minutos cuando tu carta esté disponible para descargar.',
      src: srcProcessLoading,
      srcMobile: srcProcessLoadingMobile,
      srcTablet: srcProcessLoadingTablet,
      title: 'Tu solicitud está en proceso'
    },
    {
      description:
        'El documento se ha generado con éxito. Recuerda que la descarga estará vigente por ',
      descriptionBlack: '30 días.',
      src: srcProcessDownload,
      srcMobile: srcProcessDownloadMobile,
      srcTablet: srcProcessDownloadTablet,
      title
    },
    {
      description:
        'La descarga de tu documento ha cumplido 30 días de disponibilidad. Puedes solicitarlo nuevamente si es necesario.',
      src: srcProcessDownload,
      srcMobile: srcProcessDownloadMobile,
      srcTablet: srcProcessDownloadTablet,
      title
    },
    {
      description:
        'En este momento, no tienes un ciclo relativo para el periodo que solicitaste.',
      descriptionClaims:
        'El alumno no tiene un ciclo relativo para el periodo solicitado',
      src: srcProcessErr,
      srcMobile: srcProcessErrMobile,
      srcTablet: srcProcessErrTablet,
      title
    }
  ];
  const { base64File } = useSelector((state: any) => state.downloadDocument);
  const [selected, setSelected] = useState(options[0]);
  const [hasError, setHasError] = useState(false);

  const handlerDownload = () => {
    dispatch(downloadDocumentActions.downloadFile(document));
  };

  useEffect(() => {
    if (deprecated) setSelected(options[2]);
    else setSelected(options[option]);
  }, [option]);

  useEffect(() => {
    if (document) {
      handlerDownload();
    }
    return () => {
      dispatch(downloadDocumentActions.downloadFileClear());
    };
  }, [document]);

  const download = () => {
    if (!base64File) {
      setHasError(true);
      return;
    }
    downloadCertificate(base64File, fileName);
  };
  const { push } = useHistory();
  const paramClaims = 'TA0047';
  const goToTicket = () => {
    push(
      `${routes.student.procedures.categories.tickets.register}?v=${paramClaims}`
    );
  };

  return (
    <>
      {['FINALIZADO', 'PAGO_REALIZADO'].includes(status || '') && (
        <span style={{ fontSize: 12, marginBottom: 12, display: 'block' }}>
          {dateOfPayment}
        </span>
      )}
      {active ? (
        <ReusableCard padding="24px 24px 24px 24px">
          <S.Payment data-testid="cmp-constancy-view">
            <div>
              <picture>
                <source srcSet={selected.src} media="(min-width: 768px)" />
                <source
                  srcSet={selected.srcTablet}
                  media="(min-width: 640px)"
                />
                <img src={selected.srcMobile} alt="selected" />
              </picture>
            </div>
            <div>
              <ReusableTitle
                fontSize="18px"
                fontWeight="900"
                lineHeight="28px"
                title={selected.title}
                textAling
              />
              <p className="status-desc" style={{ marginTop: '4px' }}>
                {option !== 3 && selected.description}
                {selected.descriptionBlack === '0801 19600 ó 315 9600' && (
                  <br />
                )}
                <b>{selected.descriptionBlack}</b>
                {selected.descriptionClaims && (
                  <p>
                    Para resolver tus dudas escríbenos a{' '}
                    <S.ElementClaim onClick={goToTicket}>
                      registro de quejas y reclamos.
                    </S.ElementClaim>
                  </p>
                )}
              </p>

              {option === 1 && !deprecated && (
                <ReusableButton
                  text="Descargar"
                  style={{ marginTop: '26px' }}
                  onClick={download}
                />
              )}
            </div>
          </S.Payment>
        </ReusableCard>
      ) : (
        ''
      )}
      <MyModal
        img={imgWarning}
        data={{
          description: <>Parece que ha ocurrido un error.</>,
          description2: (
            <>
              Si el problema persiste, por favor, envíanos tus observaciones a{' '}
              <S.ElementClaim onClick={goToTicket}>
                registro de quejas y reclamos.
              </S.ElementClaim>
            </>
          ),
          title: '¡Oh no!'
        }}
        handlerClick={() => {
          setHasError(false);
        }}
        handlerClose={() => {
          setHasError(false);
        }}
        show={hasError}
      />
    </>
  );
};

export default StepConstancy;
